#import "@/apollo/fragments/Job.gql"

query JobsById($jobIds: [ID!]) {
    jobs(jobIds: $jobIds) {
        ...Job
    }
}
